import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { ISubscription } from "rxjs/Subscription";
import { PoItemService } from "../../../../service/api/builk/poitem.service";
import { PoItemDetailModel } from "../../../../model/builk/po-item/poitem-detail.model";

@Component({
  selector: "bo-builk-po-item-detail",
  templateUrl: "./po-item-detail.component.html",
  styleUrls: ["./po-item-detail.component.scss"]
})
export class PoItemDetailComponent implements OnInit, OnDestroy {
  @ViewChild("template") template: TemplateRef<any>;
  constructor(
    private modalService: BsModalService,
    public router: Router,
    private poItemService: PoItemService
  ) {}

  modalRef: BsModalRef;
  subscription: ISubscription;
  poSurrKey: number;
  poItemDetail: PoItemDetailModel;

  ngOnInit(): void {
  }

  openModal(id: number): void {
    this.modalRef = this.modalService.show(this.template, {
      class: "modal-lg"
    });
    this.loadDetail(id);
  }

  loadDetail(id: number): void {
    this.subscription = this.poItemService.getPoItemDetailBackOffice(id)
            .subscribe(
                response => {
                  this.poItemDetail = response;
                }
            );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onClose(): void {
    this.modalRef.hide();
  }
}
